import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CreateTeamRequest } from 'edu-application/dist/competition/create-team/create-team.request';
import { InviteMemberRequest } from 'edu-application/dist/competition/invite-member/invite-member.request';
import { Competition } from 'edu-core';
import { CreateCompetitionRequest } from 'edu-application/dist/competition/create-competition/create-competition.request';
import { LoginService } from '../login/login.service';
import { CompetitionBaseViewModel } from 'edu-application/dist/competition/base/competition.base.viewmodel';
import { GetInvitationsViewmodel } from 'edu-application/dist/competition/get-all-invitations/get-invitations.viewmodel';
import { RespondToInvitationRequest } from 'edu-application/dist/competition/respond-to-invitation/respond-to-invitation.request';
import { CompetitionTeamViewModel } from 'edu-application/dist';

@Injectable({
  providedIn: 'root'
})
export class HackathonService {
  [x: string]: any;
  constructor(private http: HttpClient, private loginService: LoginService) {}

  async createTeam(team: CreateTeamRequest) {
    return this.http.post(`${environment.backend_url}/competition/teams`, team).toPromise();
  }

  async inviteMember(request: InviteMemberRequest) {
    return this.http.post(`${environment.backend_url}/invitations`, request).toPromise();
  }
  
  async getTeams() {  
    return this.http.get<CompetitionTeamViewModel[]>(`${environment.backend_url}/competition/teams`).toPromise();
  }

  async getStudentTeam(competitionId: string, studentId: string) {
    return this.http.get<CompetitionBaseViewModel[]>(`${environment.backend_url}/competition/teams/student`, {
      params: { competitionId, studentId }
    }).toPromise();
  }
  
  // async deleteTeam(teamId: string) {
  //   return this.http.delete(`${environment.backend_url}/competition/teams/${teamId}`).toPromise();
  // }

  async createCompetition(competition: CreateCompetitionRequest) {
    return this.http.post(`${environment.backend_url}/competitions`, competition).toPromise();
  }
  
  async getCompetitions() {
    return this.http.get<Competition[]>(`${environment.backend_url}/competitions`).toPromise();
  }
  
  async getAllCompetitions() {
    const userInfo = await this.loginService.getUserInfo(); 
    const userType = userInfo.type;
    // Map userType to role
    const role = userType === 'admin' ? 'admin' : 'student';
    return this.http.get<CompetitionBaseViewModel[]>(`${environment.backend_url}/competitions`, {
      params: { role }
    }).toPromise();
  }
  
  async getInvitations(studentId: string) {
    return this.http.get<GetInvitationsViewmodel>(`${environment.backend_url}/invitations/${studentId}`).toPromise();
  }
  
  async acceptInvitation(invitationId: string) {
    const userInfo = await this.loginService.getUserInfo();
    return this.http.put(`${environment.backend_url}/invitations/respond`, null, {
      params: {
        invitationId: invitationId,
        response: true,
        respondingStudentId: userInfo.userName
      }
    }).toPromise();
  }
  
  async declineInvitation(invitationId: string) {
    const userInfo = await this.loginService.getUserInfo();
    return this.http.put(`${environment.backend_url}/invitations/respond`, null, {
      params: {
        invitationId: invitationId,
        response: false,
        respondingStudentId: userInfo.userName
      }
    }).toPromise();
  }

  async deleteTeam(teamId: string, deleterUsername: string) {
    const userRole = await this.loginService.getUserInfo();
    return this.http.delete(`${environment.backend_url}/competition/teams`, {
      params: { teamId, deleterRole: userRole.type, deleterUsername }
    }).toPromise();
  }

  async deleteInvitation(invitationId: string) {
    return this.http.delete(`${environment.backend_url}/invitations/${invitationId}`).toPromise();
  }
} 